import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import CreateUserForm from "./components/CreateUserForm";
import InviteUser from "./components/InviteUser";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>

        {/* Main registration routes */}
        <Route path="/register" element={<CreateUserForm />} />
        <Route path="/register/:groupId" element={<CreateUserForm />} />

        {/* Optional */}
        <Route path="/invite" element={<InviteUser />} />

        {/* Catch-all → redirect to /register */}
        <Route path="*" element={<Navigate to="/register" replace />} />

      </Routes>
    </Router>
  );
}

export default App;
